import React from "react";

type ColorProps = {
    color?: string;
}
export const BurgerMenu: React.FC<ColorProps> = ({ color = '#FFFFFF' }) => {
    return (
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 17H24" stroke={color} />
            <path d="M0 9H24" stroke={color} />
            <path d="M0 1H24" stroke={color} />
        </svg>
    )
}
export const CloseSVG: React.FC = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.707092 24.7071L24.7071 0.707108" stroke="white" strokeWidth="2" />
            <path d="M0.707092 0.707106L24.7071 24.7071" stroke="white" strokeWidth="2" />
        </svg>
    )
}
export const BurgerMenuSVG: React.FC<ColorProps> = ({ color = '#FFFFFF' }) => {
    return (
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 17H24" stroke={color} />
            <path d="M0 9H24" stroke={color} />
            <path d="M0 1H24" stroke={color} />
        </svg>
    )
}
export const ActionBtnSVG: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#F11616" />
        <path d="M4 6L8 10L12 6" stroke="white" />
    </svg>
)
export const ActionBtnMobileSVG: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#F11616" />
    </svg>
)
export const ActionBtnReversedSVG: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#F11616" />
        <path d="M12 10L8 6L4 10" stroke="white" />
    </svg>
)
export const RateStarSVG: React.FC = () => (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="#DFC51E" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5105 0L11.7556 6.90983H19.0211L13.1432 11.1803L15.3884 18.0902L9.5105 13.8197L3.63265 18.0902L5.87779 11.1803L-6.67572e-05 6.90983H7.26536L9.5105 0Z" fill="#DFC51E" />
    </svg>
)
export const SeeMoreArrowSVG: React.FC = () => (
    <svg width="36" height="1" viewBox="0 0 36 1" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0.5H36" stroke="white" />
    </svg>
)
// SCHEDULES
export const TheaterSVG: React.FC = () => (
    <svg width="46" height="38" viewBox="0 0 46 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.0659 18.567L23.3335 7.18062C17.6284 6.63502 11.0812 8.99532 11.0812 8.99532C11.0812 8.99532 4.78908 11.9724 1.15375 16.4024L5.88621 27.7888C5.88621 27.7888 8.85141 36.7081 22.5328 36.548C32.2943 26.9644 28.0659 18.567 28.0659 18.567Z" stroke="white" stroke-width="2" stroke-miterlimit="10" />
        <path d="M13.3823 28.0378C15.1317 28.5596 17.0591 28.5063 18.8738 27.7531C20.6885 27 22.0881 25.6656 22.948 24.0585" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M13.5008 19.9962C12.5994 19.7234 11.5972 19.7531 10.6602 20.1445C9.72317 20.5359 8.99966 21.2238 8.54895 22.0541" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M22.1237 16.4143C21.2223 16.1415 20.22 16.1711 19.283 16.5626C18.346 16.954 17.6225 17.6419 17.1718 18.4721" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M34.6546 11.1361C35.384 11.7351 36.321 12.0909 37.3351 12.0909C38.3492 12.0909 39.2862 11.7351 40.0157 11.1361" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M25.3201 11.1361C26.0496 11.7351 26.9866 12.0909 28.0007 12.0909C29.0148 12.0909 29.9518 11.7351 30.6812 11.1361" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M44.6829 16.3608V4.03153C39.6184 1.3332 32.6679 1.0011 32.6679 1.0011C32.6679 1.0011 25.7175 1.3332 20.6589 4.03153V7.11534C21.5544 7.07976 22.4499 7.09755 23.3335 7.18058L28.0659 18.5669C28.0659 18.5669 30.1297 22.6826 28.0304 28.4351C29.3351 29.295 30.8651 30.1134 32.6739 30.8369C45.3649 25.7309 44.6829 16.3549 44.6829 16.3549V16.3608Z" stroke="white" stroke-width="2" stroke-miterlimit="10" />
        <path d="M37.8511 21.3186C36.4396 20.1681 34.6368 19.4742 32.6679 19.4742C31.2209 19.4742 29.8628 19.8538 28.6827 20.5121" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
)
export const MovieSVG: React.FC = () => (
    <svg width="40" height="27" viewBox="0 0 40 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.999989 24.9495L27.7117 24.9495L27.7117 1.56317L0.999989 1.56317L0.999989 24.9495Z" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M38.3032 24.9427L27.7117 20.11V6.39587L38.3032 1.5564V24.9427Z" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
)
export const IgSVG: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_569_101)">
            <path d="M12.2381 2.85645C11.7246 2.85645 11.3046 3.27652 11.3046 3.79927C11.3046 4.32202 11.7246 4.74209 12.2381 4.74209C12.7515 4.74209 13.1809 4.32202 13.1809 3.79927C13.1809 3.27652 12.7608 2.85645 12.2381 2.85645Z" fill="white" />
            <path d="M8.0653 4.06067C5.89027 4.06067 4.12598 5.82496 4.12598 7.99999C4.12598 10.175 5.89027 11.9393 8.0653 11.9393C10.2403 11.9393 12.0046 10.175 12.0046 7.99999C12.0046 5.82496 10.2403 4.06067 8.0653 4.06067ZM8.0653 10.5297C6.6744 10.5297 5.54488 9.40023 5.54488 8.00933C5.54488 6.61843 6.6744 5.48891 8.0653 5.48891C9.4562 5.48891 10.5857 6.61843 10.5857 8.00933C10.5857 9.40023 9.4562 10.5297 8.0653 10.5297Z" fill="white" />
            <path d="M11.1925 16H4.80747C2.15636 16 0 13.8436 0 11.1925V4.80747C0 2.15636 2.15636 0 4.80747 0H11.1925C13.8436 0 16 2.15636 16 4.80747V11.1925C16 13.8436 13.8436 16 11.1925 16ZM4.80747 1.50292C2.98716 1.50292 1.50292 2.98716 1.50292 4.80747V11.1925C1.50292 13.0128 2.98716 14.4971 4.80747 14.4971H11.1925C13.0128 14.4971 14.4971 13.0128 14.4971 11.1925V4.80747C14.4971 2.98716 13.0128 1.50292 11.1925 1.50292H4.80747Z" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_569_101">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export const ScrollSVG: React.FC = () => (
    <svg
        width="49"
        height="49"
        viewBox="0 0 49 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            className="scroll-circle"
            cx="24.5"
            cy="24.5"
            r="24"
            stroke="white"
            strokeWidth="1"
        />
        <path
            className="scroll-arrow"
            d="M23.7929 35.2071C24.1834 35.5976 24.8166 35.5976 25.2071 35.2071L31.5711 28.8431C31.9616 28.4526 31.9616 27.8195 31.5711 27.4289C31.1805 27.0384 30.5474 27.0384 30.1569 27.4289L24.5 33.0858L18.8431 27.4289C18.4526 27.0384 17.8195 27.0384 17.4289 27.4289C17.0384 27.8195 17.0384 28.4526 17.4289 28.8431L23.7929 35.2071ZM24.5 14.5L23.5 14.5L23.5 34.5L24.5 34.5L25.5 34.5L25.5 14.5L24.5 14.5Z"
            fill="white"
        />
    </svg>
);
export const RedArrowSVG: React.FC = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#F11616" />
        <path d="M23.2929 34.7071C23.6834 35.0976 24.3166 35.0976 24.7071 34.7071L31.0711 28.3431C31.4616 27.9526 31.4616 27.3195 31.0711 26.9289C30.6805 26.5384 30.0474 26.5384 29.6569 26.9289L24 32.5858L18.3431 26.9289C17.9526 26.5384 17.3195 26.5384 16.9289 26.9289C16.5384 27.3195 16.5384 27.9526 16.9289 28.3431L23.2929 34.7071ZM24 14H23V34H24H25V14H24Z" fill="white" />
    </svg>
)
